var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_160_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 47C38.02 47 47 38.04 47 27C47 15.98 38.02 7 27 7C15.96 7 7 15.98 7 27C7 37.8529 15.6588 46.6957 26.4405 46.9923L27 47Z",
    fill: "url(#paint0_linear_160_418)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_160_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8679 37.6666C32.7452 37.6666 37.5345 32.888 37.5345 27C37.5345 21.1226 32.7452 16.3333 26.8679 16.3333C20.9799 16.3333 16.2012 21.1226 16.2012 27C16.2012 32.7882 20.8193 37.5043 26.5695 37.6625L26.8679 37.6666Z",
    fill: "url(#paint1_linear_160_418)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_160_418)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_160_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 55C46.02 55 55 46.04 55 35C55 23.98 46.02 15 35 15C23.96 15 15 23.98 15 35C15 45.8529 23.6588 54.6957 34.4405 54.9923L35 55Z",
    fill: "white",
    fillOpacity: 0.23
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd_160_418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3173 29.6871C29.6512 26.9732 30.2323 24.5631 30.9823 22.6345C31.5892 21.0738 32.2873 19.8789 33.0114 19.0914C33.7348 18.3046 34.4079 18 35 18C35.5921 18 36.2653 18.3046 36.9886 19.0914C37.7127 19.8789 38.4108 21.0738 39.0178 22.6345C39.7708 24.5708 40.3535 26.9925 40.6868 29.7197C38.0058 30.3062 35.3536 30.4416 32.8692 30.2344C31.6317 30.1311 30.4425 29.9437 29.3173 29.6871ZM27.1543 31.1824C23.8202 30.1762 21.038 28.578 19.2689 26.6823C18.8921 26.2785 18.914 25.6457 19.3178 25.2689C19.7215 24.8921 20.3543 24.914 20.7311 25.3177C22.1553 26.8438 24.4798 28.23 27.3687 29.1552C27.7254 26.414 28.3278 23.9422 29.1183 21.9096C29.7781 20.213 30.5884 18.7718 31.5392 17.7377C32.4908 16.7027 33.6592 16 35 16C36.3409 16 37.5093 16.7027 38.4609 17.7377C39.4117 18.7718 40.222 20.213 40.8818 21.9096C41.6777 23.9563 42.283 26.4484 42.6388 29.2124C45.1089 28.4663 47.5749 27.3167 49.929 25.6791C50.3823 25.3637 51.0055 25.4756 51.3209 25.9289C51.6363 26.3823 51.5245 27.0055 51.0711 27.3209C48.4178 29.1667 45.6327 30.4365 42.85 31.2351C42.9485 32.4533 43 33.7126 43 35C43 36.5415 42.9262 38.0427 42.7862 39.4812C46.3682 40.473 49.3639 42.1424 51.2311 44.1432C51.6079 44.547 51.5861 45.1798 51.1823 45.5566C50.7785 45.9334 50.1457 45.9115 49.7689 45.5078C48.2491 43.8792 45.7041 42.41 42.5421 41.4904C42.1781 43.9744 41.6097 46.2187 40.8818 48.0904C40.222 49.787 39.4117 51.2282 38.4609 52.2623C37.5093 53.2973 36.3409 54 35 54C33.6592 54 32.4908 53.2973 31.5392 52.2623C30.5884 51.2282 29.7781 49.787 29.1183 48.0904C28.4136 46.2783 27.8583 44.1172 27.4934 41.7273C25.1465 42.4746 22.8082 43.5901 20.5711 45.1464C20.1177 45.4618 19.4945 45.3499 19.1791 44.8966C18.8637 44.4432 18.9756 43.82 19.429 43.5046C21.951 41.7501 24.5921 40.5161 27.237 39.7124C27.082 38.2038 27 36.6242 27 35C27 33.6941 27.053 32.417 27.1543 31.1824ZM29.1955 39.1944C29.0681 37.8541 29 36.4494 29 35C29 33.8668 29.0416 32.7609 29.1206 31.6918C30.2708 31.9427 31.4702 32.1246 32.703 32.2274C35.3016 32.4442 38.0742 32.3124 40.8817 31.7233C40.9592 32.7826 41 33.8779 41 35C41 36.386 40.9378 37.7311 40.821 39.0181C39.8428 38.8264 38.8316 38.6844 37.7971 38.5981C35.0681 38.3704 32.1472 38.5272 29.1955 39.1944ZM29.4355 41.1914C29.7802 43.5477 30.3142 45.6476 30.9823 47.3655C31.5892 48.9262 32.2873 50.1211 33.0114 50.9086C33.7348 51.6954 34.4079 52 35 52C35.5921 52 36.2653 51.6954 36.9886 50.9086C37.7127 50.1211 38.4108 48.9262 39.0178 47.3655C39.7028 45.6039 40.247 43.4406 40.5905 41.011C39.6428 40.8192 38.6533 40.6764 37.6308 40.5912C35.0298 40.3742 32.2449 40.5327 29.4355 41.1914Z",
    fill: "url(#paint2_linear_160_418)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_160_418",
    x: -6,
    y: -6,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_160_418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_160_418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_160_418",
    x: 0.201202,
    y: 0.333313,
    width: 53.3333,
    height: 53.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_160_418"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_160_418",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_160_418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_160_418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_160_418",
    x: -9,
    y: -9,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_160_418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_160_418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_160_418",
    x: 3.99993,
    y: 1,
    width: 62.5002,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_160_418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.537255 0 0 0 0 0.160784 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_160_418",
    result: "effect2_dropShadow_160_418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_160_418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_418",
    x1: 29.9448,
    y1: 29.6786,
    x2: -5.2028,
    y2: 46.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_418",
    x1: 28.4384,
    y1: 28.4286,
    x2: 9.69304,
    y2: 37.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_418",
    x1: 49.5406,
    y1: 48.1031,
    x2: 54.4477,
    y2: 20.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4ba971d9a364a7f7092bd10a6600c009.svg";
export { ForwardRef as ReactComponent };